module.exports = __webpack_public_path__ + "img/open-icon.0ee61afc.svg";